import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { USERAUTH_ROLE_BASE_PATH } from '../../../../../features/userauth/role/userauth-role-routing';

export const Route = createFileRoute('/_app/_platform/_context-required/role/_role')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'role-list',
        label: 'Roles',
        to: USERAUTH_ROLE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
